import { Component, Input, OnInit } from "@angular/core";
import * as moment from "moment";
import { STATUS_RA } from "src/services/sisreg.service";

@Component({
  selector: "app-card-solicitacao-regulada-component",
  templateUrl: "./card-solicitacao-regulada-component.component.html",
  styleUrls: ["./card-solicitacao-regulada-component.component.scss"],
})
export class CardSolicitacaoReguladaComponentComponent implements OnInit {
  @Input("data") solicitacao;
  @Input("ultimo") ultimo;

  constructor() { }

  ngOnInit() { }

  abrirItem() {
    this.solicitacao.selecionado = !this.solicitacao.selecionado;
  }

  dateLabel(date: string) {
    console.log(date)
    return `${moment(date, "DD/MM/YYYY").format("L")}`;
  }

  getStatus(status) {
    const inicio = STATUS_RA[status];
    return inicio.label;
  }
  getStatusColor(status) {
    const inicio = STATUS_RA[status];
    return inicio.cor;
  }

  verificarStatus(status) {
    const blackList = ["Negado/Cancelado", "Em estado de erro", "Em espera"];
    return !blackList.includes(status);
  }
}
